import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
    type MissionContext,
    MissionRiskOverviewComponent
} from 'sms-dashboard';

/**
 * Portal adapter that bridges a live mission context into the SMS
 * risk-assessment widget. Authentication is supplied once at the portal root
 * by provideSmsIntegration().
 */
@Component({
    selector: 'ff-safety-assessment',
    standalone: true,
    imports: [CommonModule, MissionRiskOverviewComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        @if (missionContext) {
            <sms-mission-risk-overview variant="in-mission" [missionContext]="missionContext" />
        }
    `
})
export class SafetyAssessmentComponent {
    @Input() missionContext: MissionContext | null = null;
}
